
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/signup",
      function () {
        return require("private-next-pages/[locale]/signup/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/signup"])
      });
    }
  